import { Injectable } from "@angular/core";
import { UserProfileService } from "./../../core/services/user.service";
import { UserObj } from "./global-service.service";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  auth_user: UserObj;

  constructor(private user_service: UserProfileService) {}

  public currentUser(): UserObj {
    return this.auth_user;
  }

  async get_user(authUser): Promise<UserObj> {
    return new Promise((resolve, reject) => {
      this.user_service.get_user_by_id(authUser.uid, "").subscribe(
        (user) => {
          this.auth_user = user;
          resolve(user);
        },
        (error) => {
          console.error("Error fetching user:", error);
          reject(error);
        }
      );
    });
  }

  async get_user_by_id(uid, email): Promise<UserObj> {
    return new Promise((resolve, reject) => {
      this.user_service.get_user_by_id(uid, email).subscribe(
        (user) => {
          this.auth_user = user;
          resolve(user);
        },
        (error) => {
          console.error("Error fetching user:", error);
          reject(error);
        }
      );
    });
  }

  get_plantRef(plantId) {
    switch (plantId) {
      case "w":
        return "IT";
      case "l":
        return "NL";
      case "s":
        return "TEST";
      case "y":
        return "GB";
      default:
        return "ADMIN";
    }
  }
}
